import { render } from "./MolProps.vue?vue&type=template&id=42c105c4&ts=true"
import script from "./MolProps.vue?vue&type=script&lang=ts"
export * from "./MolProps.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__